import {
  Button,
  Label,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Separator,
  useToast,
} from '@ais-ui/ui-core';
import { PiFunnel } from 'react-icons/pi';
import React, { SetStateAction, useMemo } from 'react';
import { capitalize } from '@ais-ui/utils';
import { EventFilters, EventFilterType } from './types';
import { useLocalization } from '@ais-ui/locale-management';
import { FilterTrigger } from '../../components/FilterTrigger';

interface EventFiltersProps {
  eventFilters: EventFilters;
  setEventFilters: React.Dispatch<SetStateAction<EventFilters>>;
}

export const EventFilter = ({
  eventFilters,
  setEventFilters,
}: EventFiltersProps) => {
  const { toast } = useToast();
  const { messages } = useLocalization();

  const typeOptions: EventFilterType[] = ['all', 'note', 'warning', 'alert'];

  const numberOfActiveFilters = useMemo(() => {
    let counter = 0;
    if (eventFilters.severity !== 'all') {
      counter = counter + 1;
    }

    return counter;
  }, [eventFilters]);

  const handleFilterChange = <K extends keyof EventFilters>(
    key: K,
    value: EventFilters[K]
  ) => {
    setEventFilters((prev: EventFilters) => ({
      ...prev,
      [key]: value,
    }));

    if (key === 'severity') {
      const description = `Events filtered by ${value} severity`;
      toast({
        title: messages.genericToastTitleSuccess,
        description: description,
      });
    } else {
      toast({
        title: messages.genericToastTitleSuccess,
        description: messages.eventsHandleFilterChangeDescriptionUpdatedEventsFilter,
      });
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <FilterTrigger
          activeFilterCount={numberOfActiveFilters}
        ></FilterTrigger>
      </PopoverTrigger>
      <PopoverContent side="left" align="start">
        <div className="mb-4 space-y-2">
          <Label className="text-lg">Filter events</Label>
          <Separator></Separator>
        </div>
        <div className="space-y-6">
          <div className="space-y-2">
            <Label>Severity</Label>
            <Select
              value={eventFilters.severity}
              onValueChange={(value: EventFilterType) =>
                handleFilterChange('severity', value)
              }
            >
              <SelectTrigger>
                <SelectValue placeholder="Select severity" />
              </SelectTrigger>
              <SelectContent>
                {typeOptions.map((option) => (
                  <SelectItem key={option} value={option}>
                    {capitalize(option)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
